import { render, staticRenderFns } from "./IndirectGatewayDetails.vue?vue&type=template&id=961ecdd6"
import script from "./IndirectGatewayDetails.vue?vue&type=script&lang=js"
export * from "./IndirectGatewayDetails.vue?vue&type=script&lang=js"
import style0 from "./IndirectGatewayDetails.vue?vue&type=style&index=0&id=961ecdd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports